export default __webpack_public_path__ + "static/media/send-filled.375e69bf.svg";